import { create } from 'zustand';
import { Profile } from '../types/profile';

interface ProfileState {
  activeProfile: Profile | null;
  setActiveProfile: (profile: Profile | null) => void;
}

export const useProfileStore = create<ProfileState>((set) => ({
  activeProfile: null,
  setActiveProfile: (activeProfile) => set({ activeProfile }),
}));
